import React from "react";

import { useTypedParams } from "react-router-typesafe-routes/dom";
import { ROUTES } from "src/routes";

import { PastPayments } from "@pages/dashboard/PastPayments";

const PastRoyalties = () => {
  const { participantId } = useTypedParams(ROUTES.Profile.AccountDetails);

  return (
    <div className="pt-5">
      <h4>Past Royalties</h4>
      <PastPayments displayBanner={false} payeeId={participantId} />
    </div>
  );
};

export default PastRoyalties;
